import * as React from "react";
import { ChatActionType } from "../../Models/ChatAction";
import { SelectHierarchiesAction } from "./SelectHierarchies";
import { SelectTopicsAction } from "./SelectTopics";
import { SelectClassifierAction } from "./SelectClassifier";
import { SelectModulesAction } from "./SelectModules";
import { SelectAgentAction } from "./SelectAgent";
import { SelectAllModulesInCategoryAction } from "./SelectAllModulesInCategoryAction";
import { ViewSqlQueriesAction } from "./ViewSqlQueriesAction";
import { ViewDebugAction } from "./ViewDebugAction";
import { SelectContactTypesAction } from "./SelectContactTypesAction";
import { AddPreExistingGraphToDashboard } from "./AddPreExistingGraphToDashboard";
import { SelectModelResult } from "./SelectModelResult";
import { SelectModelAction } from "./SelectModel";
import { PlayMontageAction } from "./PlayMontageAction";
import { SoundClipsAction } from "./SoundClipsAction";

export interface ActionProps {
    args: any;
    /**
     * A callback provided by MessageGroup that when invoked will remove the action/suggestion from the UI
     */
    remove: () => void;
}

export const ActionTypeToComponent: Record<
    ChatActionType,
    React.FunctionComponent<ActionProps>
> = {
    [ChatActionType.SelectHierarchy]: SelectHierarchiesAction,
    [ChatActionType.SelectTheme]: SelectTopicsAction,
    [ChatActionType.SelectClassifier]: SelectClassifierAction,
    [ChatActionType.SelectModule]: SelectModulesAction,
    [ChatActionType.SelectAgent]: SelectAgentAction,
    [ChatActionType.SelectAllModulesInCategory]:
        SelectAllModulesInCategoryAction,
    [ChatActionType.SelectContactType]: SelectContactTypesAction,
    [ChatActionType.AddPreExistingGraphToDashboard]:
        AddPreExistingGraphToDashboard,
    [ChatActionType.SelectModelResult]: SelectModelResult,
    [ChatActionType.SelectModel]: SelectModelAction,
    [ChatActionType.PlayMontage]: PlayMontageAction,
    [ChatActionType.ShowSoundClips]: SoundClipsAction,
    [ChatActionType.ViewSqlQueries]: ViewSqlQueriesAction,
    [ChatActionType.ViewDebug]: ViewDebugAction,
};
